/**
 * @file 获取用户id
 * @author coypan
 */



const cookie = function (key, value, options) {
    var days, time, result, decode

    // A key and value were given. Set cookie.
    if (arguments.length > 1 && String(value) !== "[object Object]") {
        // Enforce object
        options = options || {}

        if (value === null || value === undefined) options.expires = -1

        if (typeof options.expires === 'number') {
            days = (options.expires * 24 * 60 * 60 * 1000)
            time = options.expires = new Date()

            time.setTime(time.getTime() + days)
        }

        value = String(value)

        return (document.cookie = [
            encodeURIComponent(key), '=',
            options.raw ? value : encodeURIComponent(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '',
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
        ].join(''))
    }

    // Key and possibly options given, get cookie
    options = value || {}

    decode = options.raw ? function (s) {
        return s
    } : decodeURIComponent

    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null
}

/**
 *本地存储
 */
function setData(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.setItem(name, value);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.setItem(name, value);
        }
    } catch (e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.set(name, value);
    }

    return ''
}

function getData(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.getItem(name);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.getItem(name);
        }
    } catch (e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.get(name);
    }
}

const openid = cookie("openid");
const uin = cookie("uin");

const getUkey = function () {
    let key = getData('ukey');
    if (key) {
        return key;
    } else {
        let d = +new Date();
        d = 'ukey_' + [d, Math.floor(d * Math.random() * Math.random()).toString().slice(-5)].join('');
        //localStorage 写操作必须加try catch，可以统一弄个函数处理
        //不然可能会遇到溢出或safari无痕浏览写入就报错的问题
        setData('ukey', d);
        return d;
    }
}

/**
 * 获取用户id
 */
export default function () {
    return openid || uin || getUkey();
}